import { BarChart3, Loader2 } from "lucide-react"
import { TOOL_LABELS } from "@/lib/ai-types"
import type { RichToolCall } from "@/lib/ag-ui-types"

function parseMetrics(result: string | null): Array<{ label: string; value: string }> {
  if (!result) return []
  try {
    const parsed = JSON.parse(result)
    const data = parsed.data || parsed

    if (typeof data === "object" && !Array.isArray(data)) {
      return Object.entries(data)
        .filter(([, v]) => v != null && typeof v !== "object")
        .slice(0, 6)
        .map(([k, v]) => ({
          label: k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
          value: typeof v === "number" ? v.toLocaleString("pl-PL") : String(v),
        }))
    }
    return []
  } catch {
    return []
  }
}

export function AnalyticsCard({ toolCall }: { toolCall: RichToolCall }) {
  const label = TOOL_LABELS[toolCall.name] || toolCall.name
  const isDone = toolCall.status === "done"
  const metrics = parseMetrics(toolCall.result)

  return (
    <div
      className="my-2 overflow-hidden rounded-lg"
      style={{ border: "1px solid var(--border)", background: "var(--bg-surface)" }}
    >
      <div
        className="flex items-center gap-2 px-3 py-2"
        style={{ borderBottom: "1px solid var(--border)", background: "var(--bg-surface-raised)" }}
      >
        {isDone ? (
          <BarChart3 size={13} style={{ color: "var(--primary)" }} />
        ) : (
          <Loader2 size={13} className="animate-spin" style={{ color: "var(--primary)" }} />
        )}
        <span className="text-xs font-medium" style={{ color: "var(--text-primary)" }}>{label}</span>
      </div>

      {isDone && metrics.length > 0 && (
        <div className="grid grid-cols-2 gap-x-4 gap-y-1 px-3 py-2 sm:grid-cols-3">
          {metrics.map((m) => (
            <div key={m.label} className="py-1">
              <div className="text-[10px]" style={{ color: "var(--text-muted)" }}>{m.label}</div>
              <div className="text-sm font-semibold" style={{ color: "var(--text-primary)" }}>{m.value}</div>
            </div>
          ))}
        </div>
      )}

      {!isDone && (
        <div className="px-3 py-3 text-xs" style={{ color: "var(--text-muted)" }}>Analizuję dane...</div>
      )}

      {isDone && metrics.length === 0 && (
        <div className="px-3 py-2 text-xs" style={{ color: "var(--text-muted)" }}>Brak danych do wyświetlenia</div>
      )}
    </div>
  )
}
